<template>
  <div class="my-like-wrap" v-if="type !== 'movie' && type !== 'theme' && zzimList && zzimList.length > 0">
    <div class="my-often-text" v-if="type === 'program'"><p>자주 보신 프로그램이에요.<br/>구독 설정하시고 업데이트 내용을 받아보세요.</p></div>
    <div class="my-often-text" v-if="type === 'live'"><p>자주 보신 채널이에요.<br/>좋아요 설정하시고 업데이트 내용을 받아보세요.</p></div>
    <div v-for="(data, index) in zzimList" :key="index" class="my-like-list">
      <div @click="moveLink(type, data)">
        <span class="vod-img">
          <img :src="getImage(data.image)" :alt="type==='program' ? data.programtitle : data.title + '이미지'"/>
        </span>
        <span class="thumb-text-wrap">
          <span class="thumb-text-right">
            <strong v-if="type === 'program'" class="thumb-title-one">{{data.programtitle}}</strong>
            <strong v-if="type === 'live'" class="thumb-title-one-channel">{{data.channelname}}</strong>
            <span v-if="type === 'program'" class="thumb-text01"> {{data.channelname}}</span>
          </span>
        </span>
      </div>
      <button type="button" class="btn-like" @click.prevent="()=>toggleSubScribe(data)">
        <span v-if="type === 'live'">
          <AlarmOn v-if="data.zzim === 'y'"/>
          <AlarmOff v-else/>
        </span>
        <span v-if="type === 'program'">
          <UnSubscribeButton v-if="data.zzim === 'y'"/>
          <SubscribeButton v-else/>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import SubscribeButton from '@/assets/svg/common/ic_detail_plus_off.svg'
import UnSubscribeButton from '@/assets/svg/common/ic_detail_plus_on.svg'
import AlarmOn from '@/assets/svg/common/ic-detail-like-on.svg'
import AlarmOff from '@/assets/svg/common/ic-detail-like-off.svg'
import utils from '@/common/util/utils'
import { resizeThumbnail } from '@/common/image.filter'
export default {
  name: 'ZzimLikeInfo',
  components: {
    SubscribeButton,
    UnSubscribeButton,
    AlarmOn,
    AlarmOff
  },
  props: {
    type: {
      type: String
    },
    toggleSubScribe: {
      type: Function
    },
    goPlayer: {
      type: Function
    }
  },
  data () {
    return {
      zzimList: [],
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    programSort (res) {
      const programMap = {}
      res.list.forEach(data => {
        data.zzim = 'n'
        if (data.programid && !(data.programid in programMap)) {
          programMap[data.programid] = data
        }
      })
      this.zzimList = Object.values(programMap).slice(0, 10)
    },
    moveLink (type, data) {
      if (this.device === 'mobile') {
        if (type === 'live') {
          this.$router.push('/player/live?channelid=' + data.programid + '&referer=' + this.$route.fullPath)
        } else {
          this.$router.push('/player/vod?programid=' + data.programid + '&referer=' + this.$route.fullPath)
        }
      } else {
        if (type === 'live') {
          location.href = 'captvpooq://player/live?channelid=' + data.programid
        } else {
          location.href = 'captvpooq://player/vod?programid=' + data.programid
        }
      }
    }
  },
  created () {
    let limit = this.type === 'program' ? 30 : 10
    let type = this.type === 'program' ? 'vod' : this.type
    MyPooqService.watchHistory({
      limit: limit,
      offset: 0,
      orderby: 'new',
      contenttype: type,
      image: 'circle'
    }).then((res) => {
      if (this.type === 'program') {
        this.programSort(...res.data)
      } else {
        res.data[0].list.map((data) => {
          data.zzim = 'n'
        })
        this.zzimList = res.data[0].list
      }
    })
  }
}
</script>
<style>
  .my-often-text {
    text-align: center;
    border-top: 5px solid #2f2f2f;
    border-bottom: 1px solid #2f2f2f;
  }
  .my-often-text > p{
    padding: 27px 0;
    font-size: 14px;
    line-height: 1.43em;
    color: #a5a5a5;
  }
  .my-like-list{
    width: 100%;
    padding: 11px 9px;
    border-bottom: 1px solid #2f2f2f;
    position: relative;
  }

  .my-like-list > div{
    font-size: 0;
  }

  .my-like-list .vod-img,
  .my-like-list .thumb-text-wrap{
    display: inline-block;
    vertical-align: middle;
  }

  .my-like-list .vod-img img{
    position: inherit;
    width: 42px;
    height: 42px;
    min-height: 42px;
    border-radius: 50%;
  }

  .my-like-list .thumb-text-wrap{
    padding-top: 0;
    padding-left: 9px;
    padding-right: 30px;
    width: 80%;
    width: calc(100% - 107px);
    width: -webkit-calc(100% - 107px);
    width: -moz-calc(100% - 107px);
  }
  .my-like-wrap ul {
    display: table-cell;
    width: 65px;
    vertical-align: middle;
    text-align: right;
  }
  .thumb-title-one-channel{
    display: block;
    color: #a5a5a5;
    font-size: 13px;
    line-height: 18px;
  }
  .thumb-title-one{
    margin-top: 3px;
    display: block;
    color: #a5a5a5;
    font-size: 13px;
    line-height: 18px;
  }
  .thumb-text01{
    color: #a5a5a5;
    font-size: 12px;
    line-height: 15px;
  }
  .btn-like {
    /*margin:  10px 0 10px 40px*/
  }
</style>
